import React, { useContext } from "react";
import {
  Grid,
  Button,
  Popover,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import styled from "styled-components";
import { observer, useObserver } from "mobx-react";
import { toJS } from "mobx";

import CriteriaPanel from "../../common/Criteria/CriteriaPanel";
import { ContainerStoreContext } from "../../ContainerStore";
import { cloneDeep } from "lodash";

function FilterPopup({ anchorEl, onClose, onSave, isOpen }) {
  const {
    list,
    listId,
    view,
    containerStore,
    criteria: viewCriteria,
  } = useData();

  const [criteria, setCriteria] = React.useState(
    typeof viewCriteria === "object" ? viewCriteria.query_string : viewCriteria
  );
  const [columnsForCriteriaPanel, setColumnsForCriteriaPanel] = React.useState(
    []
  );
  const [isSaving, setIsSaving] = React.useState(false);
  const handleFilterButtonClick = async () => {
    setIsSaving(true);
    await containerStore.changeCriteria(criteria);
    setIsSaving(false);

    onClose();
  };

  const handleCriteriaChange = React.useCallback(
    (criteria) => {
      setCriteria(criteria);
    },
    [setCriteria]
  );

  const parseAndSortColumns = (columns, listId) => {
    let idColumn = columns.find(col => col.name.toLowerCase() === 'id');
    columns = columns.filter(col => col.name.toLowerCase() !== 'id');
  
    let starColumn = columns.filter(col => {
      const options = typeof col.options === 'string' ? JSON.parse(col.options)[0] : col.options;
      return options?.is_star_column === true && col.list_id === listId; 
    });

    let nonStarColumns = columns.filter(col => {
      const options = typeof col.options === 'string' ? JSON.parse(col.options)[0] : col.options;
      return !options?.is_star_column || col.list_id !== listId;
    });
  
    nonStarColumns.unshift(idColumn);

    let idColumnIndex = nonStarColumns.findIndex(col => col.name.toLowerCase() === 'id');
    if (idColumnIndex !== -1) {
      nonStarColumns.splice(idColumnIndex + 1, 0, ...starColumn);
    }
    return nonStarColumns;
  };
  

  React.useEffect(() => {
    TL.list.reports.ColumnsFormatter.getViewColumns(
      list,
      view,
      Ext.bind(function (columns) {
        let currentSheetColumns = TL.list.settings.lookup.CriteriaHelper.formatColumns(
          cloneDeep(columns),
          {
            listNameStr: list.name,
          }
        );
        const sortedColumns = parseAndSortColumns(currentSheetColumns,list.id);
        setColumnsForCriteriaPanel(sortedColumns);
      })
    );
  }, [list, view]);

  return (
    <PopoverStyled
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={isOpen}
      onClose={onClose}
      anchorEl={anchorEl}
      maxWidth="xl"
    >
      {/* <DialogTitle>Filter</DialogTitle> */}
      <StyledDialogContent>
        <Grid container>
          <CriteriaPanel
            onChange={handleCriteriaChange}
            value={
              typeof viewCriteria === "object"
                ? toJS(viewCriteria)
                : viewCriteria
            }
            lookupColumns={columnsForCriteriaPanel}
            lookupListId={listId}
            currentSheetColumns={columnsForCriteriaPanel}
            currentListId={listId}
            hiddenMultiLevels={false}
            floatingCriteriaButton
          />
        </Grid>
      </StyledDialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleFilterButtonClick}
          color="primary"
          disabled={isSaving}
        >
          Filter {isSaving && <CircularProgress size={18} color="inherit" />}
        </Button>
      </DialogActions>
    </PopoverStyled>
  );
}

const PopoverStyled = styled(({ className, ...props }) => (
  <Popover {...props} classes={{ paper: className }} />
))`
  && {
    max-width: 800px;
    width: 100%;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  max-height: 69vh;
`

function useData() {
  const containerStore = useContext(ContainerStoreContext);
  const currentListId = containerStore.listId;
  const listConfig = containerStore.listConfig;
  const currentViewStore = containerStore.getCurrentViewStore();

  return useObserver(() => ({
    list: listConfig.list,
    listId: currentListId,
    view: containerStore.view,
    containerStore: containerStore,
    criteria: currentViewStore?.isCriteriaModified
      ? currentViewStore?.modifiedCriteria
      : containerStore.view.criteria,
  }));
}

export default observer(FilterPopup);
